module.exports = __webpack_public_path__ + "assets/images/project/constituencies/sengkang-grc.jpg?v=35e7d9a0";